import apiService from "../api";

export const getWallet = () => {
  return apiService("/wallet/", "GET", null, true);
};


export const getAllFacilities = () => {
  return apiService(`/healthfacilities/?page=${1}&size=${100}`, "GET", null, true);
};


export const getUser2fa = () => {
  return apiService("/core/auth/mfa/user-active-methods/", "GET", null, true);
};


export const getWalletTransactions = (page: any, size: number) => {
  return apiService(`/wallet/transactions/?page=${page}&size=${size}`, "GET", null, true);
};


export const fundWallet = (gateway: string, amount: string) => {
  return apiService(
    `/wallet/deposit/?payment_gateway=${gateway}`,
    "POST",
    { amount },
    true
  );
};


export const sendOtp = (method: string, payload: Record<string, any> = {}) => {
  // Validate email for email method
  if (method === "email") {
    if (!payload.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) {
      throw new Error("Invalid email address");
    }
  }
  return apiService(
    `core/auth/${method}/activate/`,
    "POST",
    payload,
    true
  );
};


export const verifyOtp = (method: string, payload: Record<string, any> = {}) => {
  return apiService(
    `core/auth/${method}/activate/confirm/`,
    "POST",
    payload,
    true
  );
};



export const requestCode = (payload: "app" | "email") => {
  return apiService(
    `/core/auth/code/request/`,
    "POST",
    { "method": payload },
    true
  );
};



export const changePrimary = (method: string, code: string) => {
  return apiService(
    `/core/auth/mfa/change-primary-method/`,
    "POST",
    { method, code },
    true
  );
};


export const deactivatesMfa = (method: string, code: string) => {

  return apiService(
    `core/auth/${method}/deactivate/`,
    "POST", { code },
    true
  );
};










export const transferFundsBtwWallet = (
  receiverWalletType: string,
  formData: Record<string, any>
) => {
  const url = `/wallet/internal-transfer/?receiver_wallet_type=${receiverWalletType}`;

  return apiService(url, "POST", formData, true);
};

export const businesstransferFundsBtwWallet = (
  hf_id: number | undefined,
  receiverWalletType: string,
  formData: Record<string, any>
) => {
  const url = `/wallet/business/${hf_id}/internal-transfer/?receiver_wallet_type=${receiverWalletType}`;

  return apiService(url, "POST", formData, true);
};


export const changeClientPin = (
  oldPin: string, newPin: string, confirmPin: string
) => {
  const url = `/wallet/change-transaction-pin/`;

  return apiService(url, "POST", { old_pin: oldPin, pin_1: newPin, pin_2: confirmPin }, true);
};


export const changeBusinessPin = (hfId: number,
  oldPin: string, newPin: string, confirmPin: string
) => {
  const url = `/wallet/business/${hfId}/change-transaction-pin/`;
  return apiService(url, "POST", { old_pin: oldPin, pin_1: newPin, pin_2: confirmPin }, true);
};

export const createTransactionPin = (pin_1: string, pin_2: string) => {
  const url = `/wallet/transaction-pin/`;

  return apiService(url, "POST", { pin_1, pin_2 }, true);
};
